const navBarStore = {
	namespaced: true,
	state: () => ({
		me: 'navBar',
		sandBox: null,
		mainMenuData: MainMenuData,
		switchMobileDropdowns: true,
	}),
	getters: {
		me: (state) => state.me,
		mainMenuData: (state) => state.mainMenuData,
		switchMobileDropdowns: (state) => state.switchMobileDropdowns,
	},
	mutations: {
		setSandBox(state, data) {
			state.sandBox = data;
		},
		turnOffSwitchMobileDropdowns(state) {
			state.switchMobileDropdowns = false;
		},
		turnOnSwitchMobileDropdowns(state) {
			state.switchMobileDropdowns = true;
		},
	},
	actions: {
		sayHi() {
			appLog.log('HIIIIII navBar');
		},

		closeAllMobileDropdowns({ commit }) {
			commit('turnOffSwitchMobileDropdowns');

			setTimeout(() => {
				commit('turnOnSwitchMobileDropdowns');
			}, 1000);
		},
	},
};

vStore.registerModule('navBar', navBarStore);
